module.exports = __webpack_public_path__ + "static/media/pdf.6695d9ac.svg";